<form (submit)="$event.preventDefault()">
    <mat-form-field appearance="fill">
        <mat-label>Numero ordine</mat-label>
        <input matInput [(ngModel)]="numeroOrdine" name="numeroOrdine">
    </mat-form-field>
    <button mat-raised-button (click)="checkOrderStatus()">Controlla</button>
</form>

<ng-container *ngIf="statoOrdine === 0;else second">
    Digita il numero dell'ordine per verificarne lo stato.
</ng-container>
<ng-template #second>
    <ng-container *ngIf="statoOrdine === -1;else third">
        <p>Ordine bloccato nel trasferimento. Sblocca premedo il pulsante.</p>
        <button mat-raised-button (click)="unlockOrder()">Submit</button>
    </ng-container>
</ng-template>
<ng-template #third>
    <p>L'ordine {{ numeroOrdine }} risulta in stato: {{statoDescrizione}}</p>
    <p>Non sono necessarie ulteriori azioni, se non perviene entro 15 minuti, ricontrolla su questa stessa pagina.</p>
</ng-template>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
  <!-- Number Column -->
  <ng-container matColumnDef="id_ordine_ps">
    <th mat-header-cell *matHeaderCellDef> Id Ordine Prestashop </th>
    <td mat-cell *matCellDef="let element"> {{element.id_ordine_ps}} </td>
  </ng-container>
  
  <!-- Description Column -->
  <ng-container matColumnDef="stato">
    <th mat-header-cell *matHeaderCellDef> Stato </th>
    <td mat-cell *matCellDef="let element"> {{element.stato}} </td>
  </ng-container>
  
  <!-- Date Column -->
  <ng-container matColumnDef="data_import">
    <th mat-header-cell *matHeaderCellDef>Data importazione</th>
    <td mat-cell *matCellDef="let element"> {{element.data_import | date: 'dd/MM/yyyy':'+0200'+'it'}} </td>
  </ng-container>
  
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<!-- Aggiungere altro template o sistema notifiche per gestire alert per ordine non trovato, formato non compatibile etc.. -->